import React, { useState, useRef, useEffect, useContext } from "react";
import { ContestList } from "../../components"
import { useTranslation } from "react-i18next";

const Participationhistory = () => {
  const { t, i18n } = useTranslation();


  return (
    <div className="container">
      <div className="Participation" style={{ marginTop: "30px" }}>
        <h4>Participation <span>History</span> </h4>
        <p>Select the appropriate contest you want to view details</p>
      </div>
      <ContestList />
    </div>
  );
};

export default Participationhistory